export const Empty: any[] = [];